import React from "react";
const aesjs = require("aes-js");
var Buffer = require("buffer/").Buffer;
const salt = process.env.REACT_APP_CRYPTO_KEY;

export function encrypt(input) {
  let keyString = salt;
  const key = keyString.trim();
  const value = input.trim();
  const keyBuffer = aesjs.utils.utf8.toBytes(key);
  const inputBuffer = aesjs.padding.pkcs7.pad(aesjs.utils.utf8.toBytes(value));

  const escEcb = new aesjs.ModeOfOperation.ecb(keyBuffer);
  const encryptedBytes = escEcb.encrypt(inputBuffer);

  const encryptedData = Buffer.from(encryptedBytes).toString("base64");
  return encryptedData;
}

export function decryp(input) {
  const key = salt.trim();
  let data;

  data = input.trim();

  const keyBuffer = aesjs.utils.utf8.toBytes(key);
  const escEcb = new aesjs.ModeOfOperation.ecb(keyBuffer);
  const buf = Buffer.from(data, "base64");
  const decryptedBytes = escEcb.decrypt(buf);
  const decryptedText = aesjs.utils.utf8.fromBytes(decryptedBytes);

  const regex = /[\u{0001}-\u{0010}]/gu;

  const result = regex.test(decryptedText)
    ? decryptedText.replace(/[\u{0001}-\u{0010}]/gu, "")
    : decryptedText;
  return result.trim();
}
